import { Component, OnInit } from '@angular/core';
import { TableModel } from 'src/app/models/table.model';
import { Krypto, ResponseKrypto } from '../../interfaces/krypto';
import { HeadersModel, IHeadersTable, TypeCell } from 'src/app/models/headersTable.model';
import { KryptoService } from 'src/app/services/krypto.service';
import { Pagination } from 'src/app/models/pagination';
import { NzModalService } from 'ng-zorro-antd';

@Component({
  selector: 'app-kryptos',
  templateUrl: './kryptos.component.html',
  styleUrls: ['./kryptos.component.scss']
})
export class KryptosComponent implements OnInit {

  public kryptos: Krypto[] = [];
  public isLoading = false;
  public dataTable: TableModel<Krypto> = new TableModel([], this.headersTable, {
    total: 0,
    currentPage: 1,
    pageSize: 10,
    lastPage: 1
  })
  public pagination: Pagination;
  public pageSize = 10;
  isVisible: boolean = false;
  isConfirmLoading = false;
  showKeyModal: string = '';

  constructor(private kryptoService: KryptoService,
    private nzModalService: NzModalService
  ) { }

  ngOnInit(): void {
    this.getKryptos();
  }

  getKryptos(page = 1) {
    this.isLoading = true;

    this.kryptoService.getKryptos({ page, size: this.pageSize }).subscribe(
      (response: ResponseKrypto) => {

        this.kryptos = response.data.sort((a: any, b: any) => b.keyId - a.keyId) as Krypto[];

        console.log(this.kryptos);

        this.isLoading = false;
        this.pagination = {
          "total": 12,
          "currentPage": 1,
          "pageSize": 2,
          "lastPage": 32
        }
        this.dataTable = new TableModel(this.kryptos, this.headersTable, this.pagination);
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  getStatus(value, source?: string) {
    const statusMap = {
      '1': { color: 'green', label: 'Aprobado' },
      '2': { color: 'yellow', label: 'En proceso' },
      '3': { color: 'red', label: 'Rechazado' },
    };

    return statusMap[value] || { color: 'gray', label: 'Desconocido' };
  }


  get headersTable(): HeadersModel[] {
    const headers: IHeadersTable[] = [
      {
        label: 'ID',
        key: 'keyId'
      },
      {
        label: 'Detalle',
        key: 'usage'
      },
      {
        label: 'Fecha',
        key: 'createdAt',
        type: TypeCell.date
      },
      {
        label: 'Fecha de expiración',
        key: 'expirationDate',
        type: TypeCell.date
      },
      {
        label: 'Estado',
        key: 'status',
        type: TypeCell.status
      },
      {
        label: 'Action',
        key: 'keyId',
        labelCol: 'Editar',
        type: TypeCell.linkInternal,
        path: '/settings/kryptos/edit/',
      }
    ]

    return headers.map((header) => new HeadersModel(header));
  }

  anularKey(key: string): void {
    this.isVisible = true;
    this.showKeyModal = key;
  }

  handleCancel() {
    this.isVisible = false
  }

  handleOk() {
    this.isConfirmLoading = true;
    setTimeout(() => {
      this.isVisible = false;
      this.isConfirmLoading = false;
      this.kryptoService.deprecateKey(this.showKeyModal).subscribe((response) => {
        this.nzModalService.success({ nzTitle: "Se anulo llave" });
        this.getKryptos();
      });
    }, 3000);
  }

  hasPrincipalCustodio(custodios: any[]): boolean {
    return custodios?.some(custodio => custodio.isPrincipal);
  }

}
